<script lang="ts">
    import { setTypedContext } from "@lib/svelte-typed-context";
    import { BehaviorSubject } from "rxjs";
    import { onMount } from "svelte";
    import { container } from "tsyringe";

    import { ContainerQueryService } from "./ContainerQueryService";
    import { containerQueryWidthContextToken } from "./context_tokens";

    export let className: string;
    export { className as class };

    export let node: HTMLDivElement | null = null;

    const service = container.resolve(ContainerQueryService);

    const width$ = new BehaviorSubject<number>(0);

    setTypedContext(containerQueryWidthContextToken, width$);

    onMount(() => {
        let unsubscribe: (() => void) | undefined;

        if (node) {
            unsubscribe = service.subscribe(node, (width) => {
                width$.next(width);
            });
        }

        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    });
</script>

<div bind:this={node} class={className}>
    <slot {node} />
</div>
